export default __webpack_public_path__ + "static/media/our church header.0637d08d.jpg";